﻿/**
 * drop down menu Module
 * @module dropDownMenuModule
 * @namespace components.uiElements.dropDownMenuModule
 */
'use strict';

angular.module('components.uiElements.dropDownMenuModule', [])
.controller('dropDownController', require('./dropDownController.js'))
.directive('ebBasicDropDownMenu', require('./ebBasicDropDownMenuDirective.js'));


//////////////////
// WEBPACK FOOTER
// ./source/angular/components/uielements/dropdownmenu/index.js
// module id = 58
// module chunks = 0